import { memo, useEffect } from 'react';

import { useImportManagerSession } from '~/components/Import/useImportManagerSession';
import { useMainSideNavOverlay } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavOverlay';
import { WorkspaceImportsTray } from '~/components/v2/components/workspace/workspace-imports/WorkspaceImportsTray';

export const WorkspaceImports = memo(() => {
  const { hasImportSession: hasImports } = useImportManagerSession();
  const { isOpen, onOpenChange } = useMainSideNavOverlay({ id: 'imports' });

  useEffect(() => {
    if (!hasImports && isOpen) {
      onOpenChange(false);
    }
  }, [hasImports, isOpen, onOpenChange]);

  if (!hasImports) {
    return null;
  }

  return <WorkspaceImportsTray />;
});

WorkspaceImports.displayName = 'WorkspaceImports';
